/**
 * This is the same exact formatter that AVP uses, but we make two changes:
 * 1. We only apply the formatting if the value is greater than 1,000,000,000 rather than all values.
 * 2. We format using commas / periods depending on locale.
 * @param value the value to format
 * @param locale the locale to use for formatting
 */
export const formatNumberAbbreviated = (value: number | string, locale: string): string => {
	let numberValue: number;
	if (typeof value === 'string') {
		const parsedValue = Number(value);
		if (isNaN(parsedValue)) {
			return value;
		}
		numberValue = parsedValue;
	} else {
		numberValue = value;
	}

	try {
		// if the value is greater than 1,000,000,000, format it to compact
		if (numberValue >= 1_000_000_000) {
			return new Intl.NumberFormat(locale, {
				notation: 'compact',
				compactDisplay: 'short',
			}).format(numberValue);
		} else {
			return new Intl.NumberFormat(locale).format(numberValue);
		}
	} catch (e) {
		// if anything went wrong, just return the value as is
		return value.toString();
	}
};
